<div class="card shadow-lg"> <!-- *ngIf="isProductIdActive(17)" -->
    <div class="card-image">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3552a26a-7946-4dd7-8ac4-ec2116c11200/public" alt="Image of product" class="img-fluid rounded-top"/>
    </div>
    <div class="card-body">
        <h5 class="card-title">{{cardInfo.title}}</h5>
        <p>{{cardInfo.text}}</p>
        <div class="list">
            <ul>
                <li *ngFor="let item of cardInfo.array">
                    <div class="item-content">
                        <div class="item-media">
                        <i [class]="getItemClass(item)"></i>
                        </div>
                        <div class="item-inner">
                        <div class="item-title">{{item[cardInfo.listValue]}}</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="premium-icon-container">
        <button  mat-icon-button [matTooltip]="getTooltip()" class="premium-icon circle-icon"> <!-- *ngIf="isStatus('paid')" -->
            <i class="fa-solid fa-crown"></i>
        </button>
    </div>
</div>